import React, { type FC, type PropsWithChildren } from 'react'
import { type Theme, ThemeProvider } from '@mui/material'
import { SnackbarProvider } from 'notistack'
import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'

import { ErrorBoundary } from './ErrorMessage'
import { TranslationProvider, type TranslationProviderProps } from './Internationalization'
import { type AppStateProps, AppStateProvider } from './State'
import { SnackbarConfig } from './theme'

export type ReactAppInjections = TranslationProviderProps & AppStateProps & Readonly<{ theme: Theme }>

export const AppWrapper: FC<PropsWithChildren<ReactAppInjections>> = ({ internationalization, manager, usecases, children, theme }) => (
    <AppStateProvider manager={manager} usecases={usecases}>
        <TranslationProvider internationalization={internationalization}>
            <ThemeProvider theme={theme}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <SnackbarProvider {...SnackbarConfig}>
                        <ErrorBoundary>{children}</ErrorBoundary>
                    </SnackbarProvider>
                </LocalizationProvider>
            </ThemeProvider>
        </TranslationProvider>
    </AppStateProvider>
)
